"use client";
import React, { useEffect, useState } from "react";

function CookieBanner() {
  const [cookieRead, setCookieRead] = useState(false);
  const [hideBanner, setHideBanner] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    const cookies = document.cookie;
    if (cookies.includes("papa-giovanni-cookie-read=true")) {
      setCookieRead(true);
    }

    const timeout = setTimeout(() => setShowAnimation(true), 50);
    return () => clearTimeout(timeout);
  }, []);

  const handleClose = () => {
    // Set cookie for 10 years
    document.cookie =
      "papa-giovanni-cookie-read=true; path=/; max-age=" +
      60 * 60 * 24 * 365 * 10;

    setHideBanner(true);
    setTimeout(() => {
      setCookieRead(true);
    }, 500);
  };

  if (cookieRead) return null;

  return (
    <div
      className={`fixed z-[5000] bottom-0 left-0 right-0 p-3 py-5 md:p-8 bg-blue-primary bg-clr-ternity flex gap-5 md:gap-7 items-center text-[0.85rem] md:text-[0.9rem] shadow-[0px_-10px_5px_0px_rgba(0,0,0,0.1)] justify-between transition-all duration-500 ease-in-out transform
        ${
          hideBanner
            ? "translate-y-full opacity-0"
            : showAnimation
            ? "translate-y-0 opacity-100"
            : "translate-y-full opacity-0"
        }`}
    >
      <div className="space-y-3 md:space-y-5 text-white">
        <p>
          This website does not use any cookies to track or store personal data.
          Your privacy is fully respected, and no analytics, advertising, or
          third-party scripts are used that involve cookies.
        </p>
      </div>

      <div className="flex gap-5">
        <button
          onClick={handleClose}
          className="bg-white px-4 py-2 cursor-pointer transition-all ease-linear whitespace-nowrap "
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default CookieBanner;
